'use client'

import { Button } from '@/components/ui/Button'
import { track } from '@/lib/tracking'
import { usePathname } from 'next/navigation'
import { useState } from 'react'

// Asks the site for a Stripe checkout URL (api/stripe/upgrade works out who
// the reader is) and goes there. Throws with the reason when it can't.
export async function startCheckout({ surface, returnPath }) {
  track('upgrade_click', { source_surface: surface })
  const res = await fetch('/api/stripe/upgrade', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ returnPath }),
  })
  const body = await res.json()
  if (!res.ok || !body.url) throw new Error(body.error)
  window.location.href = body.url
}

// Unlimited stories for $5/month: the button that starts checkout.
export default function UpgradeButton({
  surface,
  label = 'Get unlimited for $5/month',
  variant = 'primary',
  fullWidth = false,
}) {
  const pathname = usePathname()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function upgrade() {
    setLoading(true)
    setError(null)
    try {
      await startCheckout({ surface, returnPath: pathname })
    } catch (err) {
      setError(err.message || 'Checkout is unavailable right now.')
      setLoading(false)
    }
  }

  return (
    <div>
      <Button
        onClick={upgrade}
        loading={loading}
        variant={variant}
        fullWidth={fullWidth}
      >
        {label}
      </Button>
      {error && (
        <p className="mt-2 font-sans text-xs text-destructive">{error}</p>
      )}
    </div>
  )
}
